import XLSX from 'xlsx'
/**
 * 通用的打开下载对话框方法，没有测试过具体兼容性
 * @param url 下载地址，也可以是一个blob对象，必选
 * @param saveName 保存文件名，可选
 */
function openDownloadDialog (url, saveName) {
  if (typeof url === 'object' && url instanceof Blob) {
    url = URL.createObjectURL(url) // 创建blob地址
  }
  const aLink = document.createElement('a')
  aLink.href = url
  aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  let event
  if (window.MouseEvent) event = new MouseEvent('click')
  else {
    event = document.createEvent('MouseEvents')
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
  }
  aLink.dispatchEvent(event)
}

// 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
function sheet2blob (sheet, sheetName) {
  sheetName = sheetName || 'sheet1'
  const workbook = {
    SheetNames: [sheetName],
    Sheets: {}
  }
  workbook.Sheets[sheetName] = sheet
  // 生成excel的配置项
  const wopts = {
    bookType: 'xlsx', // 要生成的文件类型
    bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
    type: 'binary'
  }
  const wbout = XLSX.write(workbook, wopts)
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
  // 字符串转ArrayBuffer
  function s2ab (s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    // eslint-disable-next-line eqeqeq
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  }
  return blob
}

function createWs (data, head) {
  const fields = []
  for (const key in head) {
    fields.push(key)
  }
  const ws = XLSX.utils.json_to_sheet(
    data,
    {
      header: fields
    }
  )
  const range = XLSX.utils.decode_range(ws['!ref'])
  for (let c = range.s.c; c <= range.e.c; c++) {
    const header = XLSX.utils.encode_col(c) + '1'
    ws[header].v = head[ws[header].v]
  }
  return ws
}

/**
 * 转换器
 * @param data
 * @param converter
 * @returns {*}
 */
function convert (data, converter) {
  if (!converter) {
    return data
  }
  data.forEach(function (value) {
    for (const key in converter) {
      value[key] = converter[key](value[key])
    }
  })
}

/**
 *
 * @param table dom元素
 * @param xlsName
 */
export function tableToExcel (selector, xlsName, dataArray = false) {
  if (dataArray) {
    var sheet = XLSX.utils.json_to_sheet(selector)
  } else {
    // eslint-disable-next-line no-redeclare
    var sheet = XLSX.utils.table_to_sheet(document.querySelector(selector))
  }
  openDownloadDialog(sheet2blob(sheet), xlsName)
}

/**
 *
 * @param data
 * @param xlsName
 * @param head
 * @param converter
 */
export function jsonToExcel (params) {
  convert(params.data, params.converter)
  let sheet
  if (params.head) {
    sheet = createWs(params.data, params.head)
  } else {
    sheet = XLSX.utils.json_to_sheet(params.data)
  }
  openDownloadDialog(sheet2blob(sheet), params.xlsName)
}
